<template>
    <section class="login hero is-alt is-fullheight">

        <div class="bvcd-login modal is-active" v-if="bvcd.isActive">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('login.bvcd.headline') }}</p>
                    <button class="delete" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body">
                    <iframe :src="bvcd.loginUrl" width="100%" height="100%" frameborder="0"></iframe>
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <a class="button" @click="closeModal()">{{ $t('generic.cancel') }}</a>
                </footer>
            </div>
        </div>

        <div class="no-campground modal is-active" v-if="noCampground">
            <div class="modal-background" @click.prevent="$router.replace({name: 'login'})"></div>
            <div class="modal-content">
                <article class="message is-danger">
                    <div class="message-header">
                        <p v-html="$t('login.errors.no-campground.headline')"></p>
                    </div>
                    <div class="message-body" v-html="$t('login.errors.no-campground.body', {SERVICE_EMAIL_LINK: SERVICE_EMAIL_LINK})"></div>
                </article>
            </div>
            <button class="modal-close" @click.prevent="$router.replace({name: 'login'})"></button>
        </div>

        <div class="hero-body">
            <div class="container">
                <article class="article-box">
                    <div class="box box-shadow">
                        <form @submit.prevent="login">
                            <h2 v-if="$route.query.redirect">
                                {{ $t('login.headline2') }}
                            </h2>
                            <h2 v-else>
                                {{ $t('login.headline') }}
                            </h2>
                            <article class="message is-danger" v-if="error">
                                <div class="message-header">
                                    {{ $t('login.errors.login-failed.headline') }}
                                </div>
                                <div class="message-body" v-html="$t('login.errors.login-failed.body', {SERVICE_EMAIL_LINK: SERVICE_EMAIL_LINK})"></div>
                            </article>
                            <p class="control has-icon">
                                <input class="input" type="email" v-model="email" :placeholder="$t('login.email')" autocomplete="username">
                                <i class="fa fa-envelope"></i>
                            </p>
                            <p class="control has-icon">
                                <input class="input" type="password" v-model="pass" :placeholder="$t('login.password')" autocomplete="current-password">
                                <i class="fa fa-lock"></i>
                            </p>
                            <p class="control">
                                <button class="button is-primary is-medium is-fullwidth login-button" type="submit" :class="{'is-loading': loading}">
                                    <i class="fa fa-unlock"></i>
                                    {{ $t('login.login') }}
                                </button>
                            </p>
                        </form>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
    import {Api} from '../../../api';
    import {AppModel} from '../../../models';
    import {EventBus, Tracking} from '../../../utils';

    export default {
        name: 'login',

        created() {
            EventBus.$on(EventBus.LOGIN_DONE, this.onLoginDone);
            EventBus.$on(EventBus.REMOTE_LOGIN_CANCELED, this.onRemoteLoginCanceled);
        },

        data() {
            return {
                SERVICE_EMAIL_LINK: AppModel.serviceEmailLink,
                HAS_BVCD: AppModel.hasBvcd,
                bvcd: {
                    isActive: false,
                    loginUrl: AppModel.bvcdLoginUrl,
                },
                email: '',
                pass: '',
                stayLoggedIn: false,
                error: false,
                loading: false,
            };
        },

        computed: {
            noCampground() {
                return this.$route.query.error === 'no-campground';
            },
        },

        watch: {
            stayLoggedIn(newValue, oldValue) {
                AppModel.setStayLoggedIn(newValue);
            },
        },

        methods: {
            login() {
                this.loading = true;
                this.error = false;
                Api.user.login(this.email, this.pass);
                Tracking.trackEvent('Login', 'loginNormal', null, null);
            },

            onLoginDone(data) {
                this.loading = false;
                if(!data.success) {
                    this.error = true;
                    Tracking.trackEvent('Login', 'login', 'failed', null);
                } else {
                    this.error = false;
                    this.$router.push(this.$route.query.redirect || '/');
                    Tracking.trackEvent('Login', 'login', 'success', null);
                }
            },

            bvcdLogin(event) {
                this.bvcd.isActive = true;
                Tracking.trackEvent('Login', 'loginBVCD', null, null);
            },

            closeModal() {
                this.bvcd.isActive = false;
            },

            onRemoteLoginCanceled() {
                this.closeModal();
            },
        }
    };
</script>

<style lang="scss">
    @import './login.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/login/login.vue